const style = {
  fontSize: 22,
  fontWeight: 600
};

export function BroadcastItemTitle(props) {
  return (<>
    <span style={ style }>{ props.text }</span>
  </>);
}
